







import { Component, Vue, Prop } from 'vue-property-decorator';
import LoaderIndicator from '@/components/LoaderIndicator/index.vue';

@Component({
  components: { LoaderIndicator },
})
export default class Loader extends Vue {
  @Prop({ default: 'Fetching data...' }) private title!: string;
  @Prop(Boolean) private isActive!: boolean;
}
